import React from 'react';

interface FormFieldSetProps {
    children: React.ReactNode;
    legend?: string;
    className?: string;
}

const FormFieldSet: React.FC<FormFieldSetProps> = ({ children, legend, className="" }) => (
    <fieldset className={`fieldset bg-base-100 border-base-200 rounded-box border p-4 ${className}`}>
        {legend && <legend className="fieldset-legend">{legend}</legend>}
        {children}
    </fieldset>
);

export default FormFieldSet;